import React, { ReactElement, useContext } from 'react';
import { useAddActionDialogForContenxt } from 'react-components/dialog-forms/hooks/use-add-action-dialog';
import { useAddressDialogForContext } from 'react-components/dialog-forms/hooks/use-address-dialog';
import { useChangeLogDialogForContext } from 'react-components/dialog-forms/hooks/use-change-log-dialog';
import { useConfirmationAlertDialogForContext } from 'react-components/dialog-forms/hooks/use-confirmation-alert-dialog';
import { useCreateNeedFormDialogForContext } from 'react-components/dialog-forms/hooks/use-create-need-form-dialog';
import { useEmailAddressDialogForContext } from 'react-components/dialog-forms/hooks/use-email-address-dialog';
import { useFulfillNeedDialogForContext } from 'react-components/dialog-forms/hooks/use-fulfill-need-dialog';
import { useLinkConsentsDialogForContext } from 'react-components/dialog-forms/hooks/use-link-consents-dialog';
import { useMemberStatusChangeRequestDialogForContext } from 'react-components/dialog-forms/hooks/use-member-status-change-request-dialog';
import { useMemberSummaryFeedbackDialogForContext } from 'react-components/dialog-forms/hooks/use-member-summary-feedback-dialog';
import { usePersonalInformationDialogForContext } from 'react-components/dialog-forms/hooks/use-personal-information-dialog';
import { usePhoneNumberDialogForContext } from 'react-components/dialog-forms/hooks/use-phone-number-dialog';
import { useRichMessageDialogForContext } from 'react-components/dialog-forms/hooks/use-rich-message-dialog';
import { useTermConsentsDialogForContext } from 'react-components/dialog-forms/hooks/use-term-consents-dialog';
import { useTextConsentsDialogForContext } from 'react-components/dialog-forms/hooks/use-text-consents-dialog';
import { useTransferRequestDialogForContext } from 'react-components/dialog-forms/hooks/use-transfer-request-dialog';
import { useViewConsentsHistoryDialogForContenxt } from 'react-components/dialog-forms/hooks/useViewConsentsHistoryDialog';
import { useAssignPhoneCallDialogForContext } from 'react-components/form-dialog/hooks/use-assign-phone-call-dialog';
import { useAssignPhoneNumberDialogForContext } from 'react-components/form-dialog/hooks/use-assign-phone-number-dialog';
import { useAssignTextMessageDialogForContext } from 'react-components/form-dialog/hooks/use-assign-text-message-dialog';
import { useMessageDialogForContext } from 'react-components/form-dialog/hooks/useMessageDialog';
import { useAssignCallAuditorDialogForContext } from 'react-components/form-dialog/hooks/use-assign-call-auditor-dialog';
import { useLearnMoreDialogForContext } from 'react-components/dialog-forms/hooks/useLearnMoreDialog';
import { useAssignedSurveyDialogForContext } from 'react-components/dialog-forms/hooks/useAssignedSurveyDialog';
import { useHospitalizationDialogForContext } from 'react-components/dialog-forms/hooks/use-hospitalizations-dialog';

const dialogHooks: (() => {
  component: ReactElement;
  metadata: { [key: string]: unknown };
})[] = [
  useAddActionDialogForContenxt,
  useAddressDialogForContext,
  useAssignPhoneCallDialogForContext,
  useAssignPhoneNumberDialogForContext,
  useAssignTextMessageDialogForContext,
  useMessageDialogForContext,
  useAssignCallAuditorDialogForContext,
  useChangeLogDialogForContext,
  useConfirmationAlertDialogForContext,
  useCreateNeedFormDialogForContext,
  useEmailAddressDialogForContext,
  usePersonalInformationDialogForContext,
  usePhoneNumberDialogForContext,
  useRichMessageDialogForContext,
  useTransferRequestDialogForContext,
  useMemberSummaryFeedbackDialogForContext,
  useMemberStatusChangeRequestDialogForContext,
  useFulfillNeedDialogForContext,
  useTextConsentsDialogForContext,
  useLinkConsentsDialogForContext,
  useTermConsentsDialogForContext,
  useViewConsentsHistoryDialogForContenxt,
  useLearnMoreDialogForContext,
  useAssignedSurveyDialogForContext,
  useHospitalizationDialogForContext,
];

export const DialogContext = React.createContext<{ [key: string]: unknown }>(
  {}
);
export const useDialogContext = () => useContext(DialogContext);

export const DialogProvider = (props: { children }) => {
  const components: ReactElement[] = [];
  let metadata: { [key: string]: unknown } = {};
  for (const useHook of dialogHooks) {
    const { component: hookComponent, metadata: hookMetadata } = useHook();
    components.push(hookComponent);
    metadata = { ...metadata, ...hookMetadata };
  }
  return (
    <DialogContext.Provider value={metadata}>
      {components}
      {props.children}
    </DialogContext.Provider>
  );
};
